<ng-container>
  <img [src]="tooltipImage">
</ng-container>
